import { useState, useMemo, useEffect, useRef } from "react";
import { AgGauge } from "ag-charts-react";
import "ag-charts-enterprise";
import { LicenseManager } from "ag-charts-enterprise";
import { AGGRID_LICENCE_KEY, AlertMessagesService, LoaderComponent, Utils } from "../../../../../shared";
import { PlacementDetailsTableService } from "../../../../placements";
import { useNavigate } from "react-router-dom";

LicenseManager.setLicenseKey(AGGRID_LICENCE_KEY);

export default function TaxonomyComplianceCard({ campaignId, versionOneApi }) {
  const navigate = useNavigate();
  // const [shouldShowSpinner, setShouldShowSpinner] = useState(false);
  const [taxonomyCompliance, setTaxonomyCompliance] = useState(0);
  const isMountedRef = useRef(true);

  const getTaxonomyDataFromPlacement = async () => {
    // setShouldShowSpinner(true);
    try {
      const response = await PlacementDetailsTableService.getPlacementsWithDeliveredCached(
        campaignId,
        undefined,
        versionOneApi,
        60 * 60 * 1000
      );
      const items = response?.data?.Items || [];

      const total = Array.isArray(items) ? items.length : 0;
      const matched = Array.isArray(items)
        ? items.filter((p) => (p?.taxonomy_status || '').toLowerCase() === 'taxonomy match').length
        : 0;
      const compliance = total ? Number(((matched / total) * 100).toFixed(2)) : 0;
      if (isMountedRef.current) setTaxonomyCompliance(compliance);
    } catch (error) {
      const errorMessage = error?.response?.data?.error?.message;
      const bodyMsgArr = errorMessage ? [`Error description:\n${errorMessage}`] : [];
      AlertMessagesService.showMultipleAlerts([{
        type: 'danger',
        retryBtnText: 'Retry',
        retryBtnEvent: () => getTaxonomyDataFromPlacement(),
        title: 'Placement API cannot be loaded',
        bodyMsgArr,
      }]);
      throw error;
    } finally {
      // if (isMountedRef.current) setShouldShowSpinner(false);
    }
  }


  const getComplianceMessage = useMemo(() => {
    if (taxonomyCompliance === 100) {
      return "Great job! 100% of your placements are taxonomy compliant.";
    }

    return "Please edit taxonomy to ensure 100% compliance across all placements.";
  }, [taxonomyCompliance]);

  const options = useMemo(() => ({
    type: "radial-gauge",
    value: Math.floor(taxonomyCompliance),
    startAngle: -180,
    endAngle: 180,
    innerRadius: 50,
    outerRadius: 58,
    scale: {
      min: 0,
      max: 100,
      label: {
        enabled: false,
      },
    },
    bar: {
      fills: [{ color: "#96F5E6" }, { color: "#53CFBC" }],
      fillMode: "continuous",
    },
    label: {
      formatter({ value }) {
        return `${value.toFixed(0)}%`;
      },
      fontSize: 12,
      fontWeight: "bold",
      color: "#23A793",
    },
    secondaryLabel: {
      text: "Compliant",
      fontSize: 10,
      fontWeight: 400,
      color: "#23A793",
    },
  }), [taxonomyCompliance]);

  useEffect(() => {
    isMountedRef.current = true;
    if (campaignId) getTaxonomyDataFromPlacement();
    return () => { isMountedRef.current = false; };
  }, [campaignId, versionOneApi]);

  const handleEditPlacementClick = () => {
    Utils.navigateToComponent({id: campaignId}, 'placementDetailsTable', {navigate});
  }

  return (
    <div className="info-card taxonomy-compliance-card">
      {/* <div style={{ position: 'absolute', top: '0px' }}>
        <LoaderComponent spinnerCount={shouldShowSpinner ? 1 : 0} displayWholePage={false} />
      </div> */}
      <div className="card-content">
        <div className="first-row">
          <div className="left-column">
            <AgGauge options={options} />
          </div>
          <div className="right-column">{getComplianceMessage}</div>
        </div>
        <div className="second-row" onClick={handleEditPlacementClick}>
          <div className="edit-taxonomy-banner">
            <span className="edit-taxonomy-text">Edit Taxonomy</span>
            <div className="edit-taxonomy-card-arrow">
              <omni-icon class="is-size-1" icon-id="icon:interactive:right" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
